import { WriteRequest } from "~/backendApis/foundation/WriteRequest"

interface Params {
  userProfileImagePath: string
}

export class ChangeUserProfileImageWriteRequest extends WriteRequest<void> {
  private readonly endpoint: string =
    "/user_profile/user/edit/base_information/change_image"
  private readonly params: Params

  constructor(params: Params) {
    super()
    this.params = params
  }

  public post(): Promise<void> {
    return this.apiClient.post(this.endpoint, this.params)
  }
}
